export const fontWeight = (weight: number): string => {
  return `
  font-weight: ${weight};
  font-variation-settings: "wght" ${weight};`
}
